module.exports = __webpack_public_path__ + "assets/img/14.044231ec.gif";